import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { CommandPalette } from '../cmdk/command-palette';
import { MobileBottomNav } from './mobile-bottom-nav';
import { Sidebar } from './sidebar';
import { TopBar } from './topbar';

export function AppShell() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCmdkOpen, setIsCmdkOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      <div className="flex flex-1 flex-col">
        <TopBar
          onMenuClick={() => setIsSidebarOpen(true)}
          onCmdkClick={() => setIsCmdkOpen(true)}
        />

        <main className="flex-1 overflow-auto p-4 pb-24 sm:p-6 lg:pb-6">
          <Outlet />
        </main>
      </div>

      <MobileBottomNav onMenuClick={() => setIsSidebarOpen(true)} />
      <CommandPalette isOpen={isCmdkOpen} onClose={() => setIsCmdkOpen(false)} />
    </div>
  );
}
